import React from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { withRouter } from "react-router"
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { domainActions } from '../../store/domainStore';
import { Formik, Form } from 'formik';
import BbInput from '../styling/bbInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { selectDefaultStyles } from '../styling/selectDefaultStyles';
import SelectOption from '../searchSections/selectOption'

const SUMMARY_DOMAIN = "summary-overviews";
const DIVISION_DOMAIN = "divisions";

class RatioBookSummaryOverviewsForm extends React.Component {
    state = {}

    componentDidMount() {
        this.props.ensureDomainData("summary-overviews");
        this.props.ensureDomainData("divisions");
    }

    render() {
        return (
            <Formik
                ref={(el) => this.formRef = el}
                enableReinitialize={true}
                initialValues={{
                    reportYear: this.props.recentYear,
                    summary: '01',
                    division: '00'
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    this.submitSearch(values)
                }}
            >
                {({ values, setFieldValue }) => (
                    <Form onChange={this.handleBranchesFormChange} >                        
                        <div className="columns">
                            <div className="column is-6">
                                <BbInput type='select-noformik' label={this.props.translate('RatioBook.Common.Output')}
                                    formatOptionLabel={SelectOption} placeholder={{ type: 'column' }}
                                    value={(this.getSummaryOverviews().find(op => {
                                        return op.value === values.summary
                                    }) || {})}
                                    options={this.getSummaryOverviews()}
                                    onChange={(e) => setFieldValue('summary', e.value)}
                                />
                            </div>
                            <div className="column is-6">
                                <BbInput type='select-noformik' label={this.props.translate('RatioBook.Common.For')}
                                    formatOptionLabel={SelectOption} placeholder={{ type: 'column' }}
                                    value={(this.getDivisions().find(op => {
                                        return op.value === values.division
                                    }) || {})}
                                    options={this.getDivisions()}
                                    onChange={(e) => setFieldValue('division', e.value)}
                                    styles={selectDefaultStyles}
                                />
                            </div>
                        </div>
                        <div className='columns m-0 is-centered has-text-centered'>
                            <div className='column is-narrow'>
                                <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                    type='submit'
                                    style={{ fontWeight: 600 }}
                                    disabled={this.props.isSearching}
                                >
                                    {this.props.isSearching ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Search.Common.Search' />}
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }

    getSummaryOverviews = () => {
        if (this.props[SUMMARY_DOMAIN].isRequesting || this.props[SUMMARY_DOMAIN].requestResult === null) {
            return [];
        }
        else {
            let result = [];
            this.props[SUMMARY_DOMAIN].requestResult.map((s => {
                result.push({ value: s.value, label: s.label, shortening: s.shortening });
            }))
            return result;
        }
    }

    getDivisions = () => {
        if (this.props[DIVISION_DOMAIN].isRequesting || this.props[DIVISION_DOMAIN].requestResult === null) {
            return [];
        }
        else {
            let result = [];
            this.props[DIVISION_DOMAIN].requestResult.map((s => {
                result.push({ value: s.value, label: s.label, shortening: s.shortening });
            }))
            return result;
        }
    }

    submitSearch(values) {
        if (values.reportYear !== "" && values.summary !== "" && values.division !== "") {
            this.props.history.push(`/search/ratiobook/overview/${values.reportYear}/${values.summary}/${values.division}`);
        }
    }
}

export default withRouter(withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(RatioBookSummaryOverviewsForm)));